import { render, staticRenderFns } from "./HomeworkDoRight.vue?vue&type=template&id=0369ca80&"
import script from "./HomeworkDoRight.vue?vue&type=script&lang=js&"
export * from "./HomeworkDoRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports